import React from 'react';
import ReactDOM from 'react-dom';
import { StockLocations } from '../StockLocations';
import FocusTrap from 'focus-trap-react';
export const StockModal = ({
    onClickOutside,
    onKeyDown,
    modalRef,
    buttonRef,
    closeModal,
    itemListingId
}) => {
    return ReactDOM.createPortal(
        <FocusTrap>
            <aside
                tag="aside"
                role="dialog"
                tabIndex="-1"
                aria-modal="true"
                className="modal-cover"
                onClick={onClickOutside}
                onKeyDown={onKeyDown}
            >
                <div className="modal-area" ref={modalRef} style={{ maxWidth: "800px" }}>
                    <button
                        ref={buttonRef}
                        aria-label="Close Modal"
                        aria-labelledby="close-modal"
                        className="_modal-close"
                        onClick={closeModal}
                    >
                        <span id="close-modal" className="_hide-visual">
                            Close
                        </span>
                        <svg className="_modal-close-icon" viewBox="0 0 40 40">
                            <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
                        </svg>
                    </button>
                    <div className="modal-body">
                        <StockLocations itemListingId={itemListingId} />
                        <center>
                            <button onClick={closeModal} className="form-control btn btn-outline-primary">
                                Close
                            </button>
                        </center>
                    </div>
                </div>
            </aside>
        </FocusTrap>,
        document.body
    );
};

export default StockModal;